import { RichTextEditorToolbarStyled } from '../RichTextEditor.styles';
import { RichTextEditorToolbarPluginProps } from '../RichTextEditor.types';
import UndoRedoButtons from './toolbar/history/UndoRedoButtons';
import CleanHTMLButton from './toolbar/html/CleanHTMLButton';
import ToggleEditHTMLModeButton from './toolbar/html/ToggleEditHTMLModeButton';
import AddLinkButton from './toolbar/link/AddLinkButton';
import ListButtons from './toolbar/list/ListButtons';
import TogglePreviewModeButton from './toolbar/preview/TogglePreviewModeButton';
import InsertBlockquoteButton from './toolbar/text/InsertBlockquoteButton';
import InsertVariableButton from './toolbar/text/InsertVariableButton';
import TextAlignmentButtons from './toolbar/text/TextAlignmentButtons';
import TextColorButton from './toolbar/text/TextColorButton';
import TextFontFamilyButton from './toolbar/text/TextFontFamilyButton';
import TextFormattingButtons from './toolbar/text/TextFormattingButtons';

const ToolbarPlugin = ({
  htmlEditorRef,
  isHTMLEditModeEnabled,
  isPreviewModeEnabled,
  setHTMLEditModeEnabled,
  setIsPreviewModeEnabled,
  toolbarSettings,
}: RichTextEditorToolbarPluginProps) => {
  return (
    <RichTextEditorToolbarStyled className="toolbar">
      <InsertVariableButton
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <UndoRedoButtons
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <TextFontFamilyButton
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <TextFormattingButtons
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <TextAlignmentButtons
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <ListButtons
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <TextColorButton
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <AddLinkButton
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <InsertBlockquoteButton
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <ToggleEditHTMLModeButton
        disabled={isPreviewModeEnabled}
        htmlEditorRef={htmlEditorRef}
        isHTMLEditModeEnabled={isHTMLEditModeEnabled}
        setHTMLEditModeEnabled={setHTMLEditModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <TogglePreviewModeButton
        disabled={isHTMLEditModeEnabled}
        isPreviewModeEnabled={isPreviewModeEnabled}
        setIsPreviewModeEnabled={setIsPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
      <CleanHTMLButton
        disabled={isHTMLEditModeEnabled || isPreviewModeEnabled}
        toolbarSettings={toolbarSettings}
      />
    </RichTextEditorToolbarStyled>
  );
};

export default ToolbarPlugin;
